module.exports = __webpack_public_path__ + "img/img57.4447aefe.svg";